import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CaramelImg from "./assets/caramel.png";
import CinnImg from "./assets/cinn.png";
import CncImg from "./assets/cnc.png";
import CocoaImg from "./assets/cocoa.png";
import CpbImg from "./assets/cpb.png";
import MochaImg from "./assets/mocha.png";
import StrawbImg from "./assets/strawb.png";
import VanImg from "./assets/van.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionMui from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { useState } from "react";
import styles from "./styles.module.scss";
const Accordion = ({ data, defaultExpandedIndex, singleExpand, onChange }) => {
    const [expanded, setExpanded] = useState(defaultExpandedIndex ?? (singleExpand ? null : []));
    const handleChange = (index) => {
        if (singleExpand) {
            setExpanded(expanded === index ? null : index);
        }
        else {
            const newExpanded = Array.isArray(expanded) ? [...expanded] : [];
            const idx = newExpanded.indexOf(index);
            if (idx === -1) {
                newExpanded.push(index);
            }
            else {
                newExpanded.splice(idx, 1);
            }
            setExpanded(newExpanded);
        }
        if (onChange) {
            onChange(index);
        }
    };
    const isExpanded = (index) => {
        if (Array.isArray(expanded)) {
            return expanded.includes(index);
        }
        return expanded === index;
    };
    return (_jsx(_Fragment, { children: data.map((item, index) => (_jsxs(AccordionMui, { expanded: isExpanded(index), onChange: () => handleChange(index), className: styles.accordionItem, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), "aria-controls": `panel${index}-content`, id: `panel${index}-header`, className: styles.accordionSummary, children: item.title }), _jsx(AccordionDetails, { className: styles.accordionDetails, children: typeof item.content === "string" ? _jsx("p", { children: item.content }) : item.content })] }, index))) }));
};
const flavors = [
    {
        title: "Rich Cocoa",
        img: CocoaImg,
    },
    {
        title: "Sea Salt Caramel",
        img: CaramelImg,
    },
    {
        title: "Madagascar Vanilla",
        img: VanImg,
    },
    {
        title: "Caffé Mocha",
        img: MochaImg,
    },
    {
        title: "Strawberry Cream",
        img: StrawbImg,
    },
    {
        title: "Chocolate Peanut Butter",
        img: CpbImg,
    },
    {
        title: "Cookies & Cream",
        img: CncImg,
    },
    {
        title: "Cinnamon Toast",
        img: CinnImg,
    },
];
const flavorData = flavors.map((f) => ({
    title: f.title,
    content: (_jsx("img", { style: { width: "100%", height: "auto" }, src: f.img, alt: `Nutrition label for ${f.title} flavor boost` })),
}));
const FlavorAccordion = () => {
    return (_jsx("div", { style: { marginTop: "40px" }, children: _jsx(Accordion, { data: flavorData, defaultExpandedIndex: null, singleExpand: false }) }));
};
export default FlavorAccordion;
